const PREFIX = 'lieferbar - ';

/**
 *
 *
 *
 *
 */
export function stripLieferbarPrefix(text: string | null | undefined): string | undefined {
    if (!text) return undefined;
    const stripped = text.startsWith(PREFIX) ? text.slice(PREFIX.length) : text;
    return stripped || undefined;
}
